import React, { useEffect, useState } from 'react'
import { Button, Form, Modal, Nav } from 'react-bootstrap'
import filtericon from "../../assets/images/Filter.png";
import DataTable from 'react-data-table-component';
import { RiArrowDownSLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { BsThreeDots } from "react-icons/bs";
import Loader from '../../components/loader/loader';
import { Box, Paper, Tooltip } from "@mui/material";
import moment from 'moment';
import ordernew from '../../assets/images/order-new.png';
import deleteIcon from "../../assets/images/delete.png";
import editIcon from "../../assets/images/edit.png";
import viewIcon from "../../assets/svg/view.svg";
import CustomisedModal from '../../components/Modal/CustomisedModal';
import { FaRegSquarePlus } from 'react-icons/fa6';
import * as yup from 'yup';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { deleteBannerItem } from '../../api/context/banner';
import toast from 'react-hot-toast'
import imageToBase64 from 'image-to-base64/browser';
import { checkUserPermissions } from '../../helpers/permission';
import CreateBrand from './CreateBrand';
import { createBrand, deleteBrandCategory, deleteBrandItem, editBrand, fetchAllBrandAdmin, getBrandDetails, getBrandListing } from '../../api/context/brand';
import { getCategoryListingPaginate, getSubCategoryListingPaginate } from '../../api/context/manufacturer';
import { IoSearchOutline } from 'react-icons/io5';
import { components } from 'react-select'
import { TbGridDots } from 'react-icons/tb';
import { HiChevronDown } from 'react-icons/hi';
import { createSizeChart } from '../../api/context/sizechart';
import { FiPlus, FiTrash2 } from 'react-icons/fi';

const queueDatatableCustomStyles = {
    header: {
        style: {
            fontWeight: '600',
            fontSize: '22px',
            color: '#000',
        },
    },
    headCells: {
        style: {
            display: "flex",
            justifyContent: "center",
            fontWeight: '600',
            fontSize: '13px',
            padding: '12px 4px',
            backgroundColor: '#f9f9f9ff',
        },
    },
    cells: {
        style: {
            display: "flex",
            // justifyContent: "center",
            fontSize: '11px',
            fontWeight: '500',
            padding: '8px 4px',
        },
    },

};

const customStyless = {
    control: (provided) => ({
        ...provided,
        border: " 1px solid #EBEBEB",
        padding: '6px',
    }),
};



const Brand = () => {

    const navigate = useNavigate()

    const [sizeChartData, setSizeChartData] = useState({});
    const [sizeChartMeta, setSizeChartMeta] = useState({
        sizes: [],
        sizeTypes: []
    });
    const [isSavingSizeChart, setIsSavingSizeChart] = useState(false);
    const [showSizeChartModal, setShowSizeChartModal] = useState(false);
    const [show, setShow] = useState(false);
    const [brand, setBrand] = useState([]);
    const [category, setCategory] = useState([]);
    const [subcategory, setSubCategory] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [update, setUpdate] = useState(false);
    const [initial, setInitial] = useState(false);
    const [search, setSearch] = useState("");
    const [modal, setModal] = useState(false);
    const [deletingId, setDeletingId] = useState("");
    const [selectedBrand, setSelectedBrand] = useState(null);
    const [showmobimg, setShowMobImg] = useState(false);
    const [mobimg, setMobImg] = useState([]);
    const [isFocusedStaff, setIsFocusedStaff] = useState(false);
    const [filterState, setFilterState] = useState([{
        categories: [
            {
                categoryId: '',
                subCategories: [],
            },
        ],
    }])

    const handleShowImage = (promoimage) => {
        setShowMobImg(true);
        setMobImg(promoimage)
    }


    const handleCloseMobImage = () => {
        setShowMobImg(false);
    }

    const columns = [
        {
            name: "S. No.",
            selector: (row, index) => ((page * limit) - limit) + (index + 1),
            minWidth: '60px',
            grow: 1,
            center: true,
            cell: (row, index) => (
                <div className="text-center">
                    {((page * limit) - limit) + (index + 1)}
                </div>
            )
        },

        {
            id: 'title',
            name: 'Title',
            selector: (row) => row?.name,
            cell: (row) => (
                <div style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    textDecoration: 'underline',
                    textUnderlineOffset: '2px',
                    textDecorationThickness: '1px',
                    textDecorationColor: '#a94b4bff',
                    minWidth: 0, // Important for truncation in flex children
                }}
                    onClick={() => navigate('/edit-brand-page/' + row.id)}
                >
                    {row?.name}
                </div>
            ),
            minWidth: '120px',
            grow: 1,
            center: true
        },
        {
            id: "image",
            name: "Brand Image",
            selector: (row) => row?.image,
            cell: (row) => (
                <div className="text-center">
                    <div className="promocode_img_wrapper mx-auto" onClick={() => handleShowImage(row?.image)}>
                        <img src={row?.image} alt={row?.title} className="img-fluid" />
                    </div>
                </div>
            ),
            minWidth: '110px',
            grow: 1,
            center: true
        },
        {
            id: 'createdAt',
            name: 'Created Date',
            selector: (row) => moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a'),
            cell: (row) => (
                <div className="text-center">
                    <Tooltip title={moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement='top'>
                        <div className='text-truncate'>{moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')}</div>
                    </Tooltip>
                </div>
            ),
            minWidth: '150px',
            grow: 1,
            center: true
        },
        {
            id: 'updatedAt',
            name: 'Updated Date',
            selector: (row) => moment(row?.updatedAt).format('DD/MM/YYYY, hh:mm a'),
            cell: (row) => (
                <div className="text-center">
                    <Tooltip title={moment(row?.updatedAt).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement='top'>
                        <div className='text-truncate'>{moment(row?.updatedAt).format('DD/MM/YYYY, hh:mm a')}</div>
                    </Tooltip>
                </div>
            ),
            minWidth: '150px',
            grow: 1,
            center: true
        },
        {
            id: "action",
            name: "Action",
            cell: (row) => (
                <div className="text-center">
                    <div className="d-flex align-items-center justify-content-center">
                        <div className="d-flex flex-row gap-3" role="button">
                            <Tooltip title="Edit" disableInteractive placement="top">
                                <div
                                    className="edit_icon_bg"
                                    onClick={() => navigate('/edit-brand-page/' + row.id)}
                                // onClick={(e) => {

                                //     handleEditClick(row);
                                // }}
                                >
                                    <img src={editIcon} alt="Edit" className="edit_icon" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Delete" disableInteractive placement="top">
                                <div className="delete_icon_bg" onClick={() => handleConfirm(row?.id)}>
                                    <FiTrash2 className="delete_icon text-black fs-5" />
                                </div>
                            </Tooltip>
                        </div>
                    </div>
                </div>
            ),
            minWidth: '120px',
            grow: 1,
            center: true
        }
    ];

    const validationSchema = yup.object().shape({
        name: Yup.string()
            .required('Required'),
        image: selectedBrand?.id ? yup.string().nullable() : yup.string().required('Image is required'),
    });

    const formik = useFormik({
        initialValues: {
            name: '',
            image: '',
            image_view: '',
            categories: [
                {
                    categoryId: '',
                    subCategories: [],
                },
            ],
        },
        validationSchema: validationSchema,
        validate: async (values) => {
            const errors = {}

            return errors
        },
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);
            if (values.image == '') {
                delete values.image;
            }
            delete values.image_view;

            // Build sizeChartValues
            const sizeChartPayload = buildSizeChartPayload(sizeChartData, sizeChartMeta);
            const sizeChartValues = sizeChartPayload.values;


            const payload = {
                ...values,
                sizeChartValues,
            };
            console.log('payload when saving brand', payload);

            if (selectedBrand?.id) {
                editBrand(payload)((response) => {
                    if (response && response?.data?.statusCode == 200) {

                        resetForm();
                        toast.success("Brand Updated Successfully")
                        handleClose();
                        setUpdate(!update);
                        setSelectedBrand(null);
                        setLoading(false);
                    } else {
                        setLoading(false);
                        toast.error(response?.data?.message);
                    }
                })
            } else {
                createBrand(payload)((response) => {
                    if (response && response?.data?.statusCode == 200) {
                        resetForm();
                        toast.success("Brand Created Successfully")
                        handleClose();
                        setUpdate(!update);
                        setLoading(false);
                        setSelectedBrand(null);
                    } else {
                        setLoading(false);
                        toast.error(response?.data?.message);
                    }
                })
            }

        },
    });

    const handleShow = () => setShow(true);

    const handleClose = () => {
        formik.resetForm();
        setShow(false);
        setSelectedBrand(null)
    };

    const fetchBrandData = async () => {
        fetchAllBrandAdmin({ page: page, pageSize: limit, search })((response) => {
            if (response?.statusCode === 200) {
                setBrand(response?.data);
                setTotalRows(response?.totalRecords);
                setLoading(false);
            } else {
                setBrand([]);
                setLoading(false);
            }
        });
    };

    // Fetch categories dynamically based on input
    const loadOptionsCategory = (inputValue) => {
        return new Promise((resolve) => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                if (inputValue.length >= 2) {
                    getCategoryListingPaginate({ page: 1, limit: 10, search: inputValue })((response) => {
                        if (response?.statusCode === 200) {
                            resolve(response?.results);
                            setCategory(response?.results);
                        } else {
                            resolve([]);
                        }
                    });
                } else {
                    resolve([]);
                    setCategory([]);
                    setSubCategory([]);
                }
            }, 300);
        });
    };

    let typingTimer;
    // Fetch subcategories based on category ID
    const loadOptionsSubCategory = (inputValue, categoryId) => {
        return new Promise((resolve) => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                if (inputValue.length >= 2 && categoryId) {
                    getSubCategoryListingPaginate({
                        page: 1,
                        pageSize: 10,
                        search: inputValue,
                        categoryIds: [categoryId],
                    })((response) => {
                        if (response?.statusCode === 200) {
                            resolve(response?.results);
                            setSubCategory(response?.results);
                        } else {
                            resolve([]);
                        }
                    });
                } else {
                    resolve([]);
                    setSubCategory([]);
                }
            }, 300);
        });
    };

    // Handling category change
    const onCategoryChange = (selectedOption, index) => {
        const updatedCategories = [...formik.values.categories];
        updatedCategories[index] = {
            ...updatedCategories[index],
            categoryId: selectedOption ? selectedOption.value : '',
            selectedCategory: selectedOption,
            subCategories: [], // Reset subcategories when category changes
        };
        formik.setFieldValue('categories', updatedCategories);

    };

    // Handling subcategory change
    const onSubCategoryChange = (selectedOption, index) => {
        const updatedCategories = [...formik.values.categories];
        updatedCategories[index] = {
            ...updatedCategories[index],
            subCategories: selectedOption ? selectedOption.map((opt) => opt.value) : [],
            selectedSubCategory: selectedOption,
        };
        formik.setFieldValue('categories', updatedCategories);
    };

    const handleCategoryAdd = () => {
        const newCategory = {
            categoryId: '',
            subCategories: [],
            selectedCategory: null,
            selectedSubCategory: [],
        };

        formik.setFieldValue('categories', [
            ...formik.values.categories,
            newCategory,
        ]);
    };

    const onhandleChangeCategory = (categoryId) => {

        getSubCategoryListingPaginate({ page: 1, limit: 10, search: '', categoryIds: [categoryId] })(response => {
            if (response?.statusCode == 200) {
                setSubCategory(response?.results)
            } else {
                setSubCategory([])
            }
        })
    }


    const handleEditClick = (brand) => {
        setSelectedBrand(brand);
        setShow(true);
        setModalLoading(true);

        getBrandDetails({ id: brand?.id })(response => {
            setModalLoading(false);

            if (response && response.data?.statusCode === 200) {
                const brandData = response?.data?.data;

                // Transform the API data to match your form structure
                const transformedCategories = brandData.BrandCategories.map(item => ({
                    categoryId: item.categoryId,
                    subCategories: [item.subCategoryId], // Assuming single subcategory per category
                    selectedCategory: {
                        value: item.categoryId,
                        label: item.category.title
                    },
                    selectedSubCategory: [{
                        value: item.subCategoryId,
                        label: item.subcategory.title
                    }]
                }));

                formik.setValues({
                    id: brandData.id,
                    name: brandData.name,
                    image_view: brandData.image,
                    categories: transformedCategories
                });
            } else {
                console.error('Failed to fetch brand details:', response);
            }
        });
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setPage(1);
        setUpdate(!update);
    };

    const handlePageChange = (page) => {
        setPage(page);
        setUpdate(!update);
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    const handleConfirm = (deletingId) => {
        setModal(!modal);
        setDeletingId(deletingId);
    };





    const deleteBrand = (id) => {
        setLoading(true);
        deleteBrandItem(id)((response) => {
            if (response?.request?.status == 200) {
                setUpdate(!update);
                setModal(!modal);
                setLoading(false);
                toast.success("Brand deleted successfully")
            } else {
            }
        });
        // });
    };


    useEffect(() => {
        setLoading(true);
        fetchBrandData();
    }, [update]);


    useEffect(() => {
        let timeout = setTimeout(() => {
            if (initial) setUpdate(!update);
            else setInitial(!initial);
        }, 500);

        return () => {
            clearTimeout(timeout);
        };
    }, [search]);

    useEffect(() => {

        getCategoryListingPaginate({ page: 1, limit: 10, search: '' })(response => {
            if (response?.statusCode == 200) {
                setCategory(response?.results)
            } else {
                setCategory([])
            }
        })

    }, []);



    const customNoOptionsMessage = ({ inputValue }) => {
        return inputValue.length < 2
            ? "Please type atleast 2 characters"
            : "No options";
    };

    const deleteCategory = (brandId, categoryId) => {
        deleteBrandCategory(brandId, categoryId)((response) => {
            if (response?.data?.statusCode == 200) {
                // setUpdate(!update);
            } else {

            }
        });

    }

    const DropdownIndicator = ({ state, ...props }) => {
        return (
            <components.DropdownIndicator {...props}>

                {filterState && filterState[state] && filterState[state].length > 1 ? (
                    <TbGridDots style={{ fontSize: "1.5em" }} />
                ) : (
                    <HiChevronDown style={{ fontSize: "1.5em" }} />
                )}



            </components.DropdownIndicator>
        );
    };


    const buildSizeChartPayload = (sizeChartData, sizeChartMeta) => {
        const values = [];
        Object.entries(sizeChartData).forEach(([categoryId, subCats]) => {
            Object.entries(subCats).forEach(([subCategoryId, sizesObj]) => {
                const sizes = [];
                Object.entries(sizesObj).forEach(([sizeLabel, typeObj]) => {
                    Object.entries(typeObj).forEach(([typeLabel, measurement]) => {
                        const size = sizeChartMeta.sizes.find(
                            s => s.size === sizeLabel && String(s.subsubcategoryId) === String(subCategoryId)
                        );
                        const type = sizeChartMeta.sizeTypes.find(
                            t => t.sizeType === typeLabel && String(t.subsubcategoryId) === String(subCategoryId)
                        );
                        if (size && type && measurement !== "") {
                            sizes.push({
                                subsubCategorySizeId: size.id,
                                subsubCategorySizeTypeId: type.id,
                                measurement: Number(measurement),
                                unit: size.unit || "cm"
                            });
                        }
                    });
                });
                if (sizes.length > 0) {
                    values.push({
                        categoryId: Number(categoryId),
                        subCategoryId: Number(subCategoryId),
                        sizes
                    });
                }
            });
        });
        return {
            values
        };
    };


    return (
        <>
            <div>

                <div className="page-header-sticky">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
                        <div className="d-flex align-items-center">
                            <h3 className="mb-0 fw-bolder">Brands</h3>
                        </div>

                        <Button
                            className="request_btn"
                            onClick={() => navigate('/edit-brand-page/')}
                        >
                            <FiPlus size={18} strokeWidth={3} />
                            Add New Brand
                        </Button>
                    </div>

                    <div className="d-flex align-items-center gap-3 flex-wrap">
                        <div style={{ flex: 1, minWidth: '260px' }}>
                            <Form.Control
                                type="text"
                                className="form-control"
                                placeholder="Search for brands..."
                                onChange={(e) => setSearch(e.target.value.trim())}
                                style={{
                                    minHeight: '40px',
                                    borderRadius: '8px',
                                    fontSize: '13px',
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className='col-12'>
                    <Box className="products-and-options" sx={{ mt: 1 }}>
                        <Paper square className='shadow-none border border-blue-grey-200'>
                            <div>
                                <DataTable
                                    pointerOnHover // Adds cursor pointer on hover
                                    highlightOnHover // Adds hover effect
                                    columns={columns}
                                    data={brand}
                                    progressPending={loading}
                                    progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    onRowClicked={(row) => navigate('/edit-brand-page/' + row.id)}

                                    paginationRowsPerPageOptions={[10, 50, 100, 150]}
                                    paginationPerPage={limit}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    currentPage={page}
                                    customStyles={queueDatatableCustomStyles}
                                />
                            </div>
                        </Paper>
                    </Box>
                </div>

                <CustomisedModal
                    isOpen={modal}
                    customClass={"policy_modal"}
                    toggle={toggleModal}
                >
                    <h5>Are you sure you want to remove this item?</h5>
                    <div className="policy_Agree">
                        <Button
                            onClick={() => {
                                setModal(!modal);
                            }}
                            size="lg"
                            className="btn_cancel"
                        >
                            Cancel
                        </Button>
                        <Button
                            size="lg"
                            className="btn"
                            onClick={() => deleteBrand(deletingId)}
                            disabled={loading}
                        >
                            Delete
                        </Button>
                    </div>
                </CustomisedModal>
            </div>

            <Modal
                show={showmobimg}
                onHide={handleCloseMobImage}
                centered
                className='modal_create'
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <div className="promo_modal_img">
                    <img src={mobimg} alt='' className="img-fluid" />
                </div>
            </Modal>
        </>
    )
}

export default Brand